
import React from 'react'

import { Refaunds } from '../components/Refaunds/Refaunds'

export const Refunds = () => {
    return (
        <Refaunds />
    )
}